module.exports = __webpack_public_path__ + "assets/webgl/LM_3_0.jpg.e53a3ad8.webp";